













































import { simpleDate } from "@/lib/utility/date-helper";
import { Component, Prop } from "vue-property-decorator";
import FilterCard from "@/components/filter/FilterCard.vue";
import TheLayoutPortalList from "../../layouts/TheLayoutPortalList.vue";
import { UserPaginationModule } from "@/store/modules/admin-user-pagination.store";
import { UserEntity } from "@/models/userEntity";
import { IFilterListElement } from "@/lib/interfaces/filter/filterListElement.interface";
import { getDateFilterList } from "@/lib/utility/filter";
import { mixins } from "vue-class-component";
import DarkModeHighlightMixin from "@/mixins/DarkModeHighlightMixin.vue";
import { CancelToken } from "@/lib/utility/cancelToken";
import { UserAdministrationModule } from "@/store/modules/admin-user.store";
import UserAdministrationDetailCreateDialog from "@/components/partner/UserAdministrationDetailCreateDialog.vue";
import { handleError } from "@/lib/utility/handleError";

@Component({
  components: {
    FilterCard,
    UserAdministrationDetailCreateDialog,
    TheLayoutPortalList
  }
})
export default class UserAdministrationListPaginated extends mixins(DarkModeHighlightMixin) {
  @Prop()
  loadingUser!: boolean;

  loading = true;

  isLoadingMore = false;

  isLoadingDetail = false;

  statusFilter: IFilterListElement[] = [];

  dateFilter = getDateFilterList("timestamps");

  get filterList(): IFilterListElement[] {
    return [...this.dateFilter, ...this.statusFilter];
  }

  get paginationList() {
    return this.getModule().paginationList;
  }

  getModule() {
    return UserPaginationModule;
  }

  async mounted() {
    this.loading = true;

    //load from beginning
    await this.refresh();

    // set user detail
    try {
      if (this.paginationList.length === 0) {
        UserAdministrationModule.setSelectedUser({} as UserEntity);
      } else {
        UserAdministrationModule.setSelectedUser(this.paginationList[0] as UserEntity);
      }
    } catch (e) {
      this.$log.error(e);
    } finally {
      this.loading = false;
    }
  }

  async set(item: any) {
    this.$emit("update:loadingUser", true);
    await UserAdministrationModule.getIdentity(item.userName).catch(handleError);
    const user = await UserAdministrationModule.getSelectedUser(item?._id);
    if (user) {
      UserPaginationModule.replaceInList(user as any);
      if (["xs", "sm"].includes(this.$vuetify.breakpoint.name)) {
        this.$router.push({ name: "UserAdministrationDetail", params: { userId: item?._id } });
      }
    }

    this.$emit("update:loadingUser", false);
  }

  async refresh() {
    this.loading = true;
    UserPaginationModule.emptyList();
    await UserPaginationModule.fetchAllFromBeginning({});
    this.loading = false;
  }

  async loadAllFromLastId() {
    if (this.paginationList.length === 0) {
      await UserPaginationModule.fetchAllFromBeginning({});
    } else {
      UserPaginationModule.cancelToken?.requestCancellation();
      const cancelToken = new CancelToken();
      UserPaginationModule.setCancelToken(cancelToken);
      await UserPaginationModule.fetchRest({
        query: {},
        cancelToken: cancelToken
      });
    }
  }

  async loadMore() {
    try {
      this.isLoadingMore = true;
      await this.loadAllFromLastId();
    } catch (e) {
      this.$toast.error((e as any).message);
    } finally {
      this.isLoadingMore = false;
    }
  }

  isActive(item: any) {
    return item?._id === UserAdministrationModule.selectedUser?._id ? "v-item--active v-list-item--active" : "";
  }
  date(item: any): string {
    return simpleDate(item?.timestamps?.created);
  }
}
